import { ACTIONS } from "../App/AppActionTypes";
const initialState = {
  user: undefined
};

const AuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.FETCH_APP_USER.SUCCESS:
      return { ...state,
        user: action.payload
      };

    case ACTIONS.FETCH_APP_USER.FAILURE:
      return { ...state
      };

    case ACTIONS.CLEAR:
      return initialState;

    default:
      return state;
  }
};

export default AuthReducer;